import * as Types from '../generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type FilestackQueryVariables = Types.Exact<{ [key: string]: never }>;

export type FilestackQuery = { __typename?: 'Query'; filestack: { __typename?: 'Filestack'; apiKey: string; policy: string; signature: string } };

export const FilestackDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Filestack' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'filestack' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'apiKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signature' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFilestackQuery__
 *
 * To run a query within a React component, call `useFilestackQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilestackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilestackQuery({
 *   variables: {
 *   },
 * });
 */
export function useFilestackQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FilestackQuery, FilestackQueryVariables>) {
  return ApolloReactHooks.useQuery<FilestackQuery, FilestackQueryVariables>(FilestackDocument, baseOptions);
}
export function useFilestackLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FilestackQuery, FilestackQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<FilestackQuery, FilestackQueryVariables>(FilestackDocument, baseOptions);
}
export type FilestackQueryHookResult = ReturnType<typeof useFilestackQuery>;
export type FilestackLazyQueryHookResult = ReturnType<typeof useFilestackLazyQuery>;
export type FilestackQueryResult = Apollo.QueryResult<FilestackQuery, FilestackQueryVariables>;
